import {usePathname, useRouter} from "next/navigation";
import {useCallback} from "react";

/**
 * Clears all search params from the current url
 *
 * ex: /courses/course/la-level-2?class=123 -> /courses/course/la-level-2
 * @returns a function which clears all search params from the current page's url when called
 */
export const useClearSearchParams = () => {
	const router = useRouter();
	const pathname = usePathname();
	const clearSearchParams = useCallback(() => {
		router.replace(pathname, {scroll: false});
	}, [router, pathname]);
	return clearSearchParams;
};
